export enum GameState {
  LOADING,
  HOME,
  WEAPON_SELECT,
  STAGE_SELECT,
  PLAYING,
  PAUSED,
  LEVEL_CLEAR,
  GAME_OVER,
}

export enum ZombieState {
  IDLE,
  WANDER,
  ALERT,
  CHASE,
  FLANK,
  ATTACK,
  DEAD,
}

export enum Difficulty {
  EASY = 'easy',
  NORMAL = 'normal',
  HARD = 'hard',
}

export interface WeaponConfig {
  id: string;
  name: string;
  nameKey: string;
  damage: number;
  fireRate: number;
  magazineSize: number;
  reloadTime: number;
  range: number;
  spread: number;
  pellets: number;
  isExplosive: boolean;
  explosionRadius: number;
  isAutomatic: boolean;
  price: number;
}

export interface ZombieConfig {
  id: string;
  name: string;
  hp: number;
  damage: number;
  speed: number;
  detectionRange: number;
  attackRange: number;
  reward: number;
  minStage: number;
}

export interface BossVisual {
  bodyColor: number;
  skinColor: number;
  emissiveColor: number;
  crownColor: number;
  auraColor: number;
  hornColor: number;
  scale: number;           // additional scale on top of 1.5x boss base
  torsoWidthMult: number;  // 1.0 = normal
  headSizeMult: number;    // 1.0 = normal
  hunchAngle: number;
}

export interface BossWeakPoint {
  zone: 'head' | 'chest' | 'back' | 'belly' | 'legs';
  damageMultiplier: number;  // e.g. 3.0 = 3x damage when hit here
  glowColor: number;         // visual indicator color
}

export interface BossConfig extends ZombieConfig {
  stage: number;
  abilities: string[];
  abilityCooldown?: number;  // override default 7s cooldown
  visual?: BossVisual;
  weakPoint?: BossWeakPoint;
}

export interface StageConfig {
  id: number;
  nameKey: string;
  theme: string;
  description: string;
}

export interface LevelConfig {
  stage: number;
  level: number;
  zombieCount: number;
  zombieTypes: string[];
  hpMultiplier: number;
  damageMultiplier: number;
  speedMultiplier: number;
  hasBoss: boolean;
}

export interface SaveData {
  playerData: {
    coins: number;
    weapons: Record<string, { owned: boolean; level: number }>;
    progress: Record<string, { levelsCleared: number; unlocked: boolean }>;
  };
  settings: {
    language: 'ja' | 'en';
    difficulty: Difficulty;
    soundVolume: { bgm: number; se: number };
  };
}

export interface LevelStats {
  kills: number;
  coins: number;
  time: number;
}

export interface DifficultyModifiers {
  playerHp: number;
  regenRate: number;
  zombieHpMultiplier: number;
  zombieDamageMultiplier: number;
  zombieSpeedMultiplier: number;
  coinMultiplier: number;
  detectionRangeMultiplier: number;
}
